export default __webpack_public_path__ + "static/media/component_play_shield_top.c7ff3dfe.png";